import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-impostazioni',
  templateUrl: 'impostazioni.html',
})
export class Impostazioni extends Util {
  pagine: any;
  user: any;
  mjl: any;
  page: string;
  promemoria: boolean = false;
  promemoria_2: boolean = false;
  promemoria_3: boolean = false;
  settings = { avvisoSfideApp: 0, avvisoSfideMail: 0, memoApp: 0, memoMail: 0, oraPromemoria: '12:00' };
  getbg = { allena: {}, apprendi: {}, competenze: {}, shop: {} };
  percent_hat = '20%';
  hpromemoria = '00:00';
  token:string = '';
  language = 'it';
  constructor(public navCtrl: NavController,public translate:TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    //this.user = this.navParams.get('user');
    this.page = 'dash';

    this.language = this.translate.getDefaultLang();
  }
  ionViewDidEnter() {
    this.refreshpage();
  }
  refreshpage() {

    // this.storage.get('user').then((user) => {
    this.GetRequest('me','',true,false).then((user:any)=>{ 
      //console.log(user['user']);
      this.user = user['user'];
      
      if (this.user.avvisoSfideApp == '0' || this.user.avvisoSfideApp == null)
        this.settings.avvisoSfideApp = 0;
      else
        this.settings.avvisoSfideApp = 1;

      if (this.user.avvisoSfideMail == '0' || this.user.avvisoSfideMail == null)
        this.settings.avvisoSfideMail = 0;
      else
        this.settings.avvisoSfideMail = 1;

      if (this.user.memoApp == '0' || this.user.memoApp == null)
        this.settings.memoApp = 0;
      else
        this.settings.memoApp = 1;

      if (this.user.memoMail == '0' || this.user.memoMail == null)
        this.settings.memoMail = 0;
      else
        this.settings.memoMail = 1;

      this.settings.oraPromemoria = this.user.oraPromemoria;
    })
  }

  update_user() {
    this.PutRequest('utente', this.user.id, this.settings).then((res) => {
      //console.log(res);

      for (let key in this.settings) {
        for (let keyu in this.user)
          if (key == keyu)
            this.user[keyu] = this.settings[key];
      }
      // this.storage.set('user', this.user);

      

    }).catch((e) => {
      //this.navCtrl.push(Mj_Detail,{mj:m});
      console.error(e)
    })
  }
  send_token(){
    this.PostRequest('attivaToken',this.token,{},true,true).then((res:any)=>{
      //console.log(res);
      this.showBasicAlert('Token',res.message);
    }).catch((err)=>{
      console.error(err);
    })
  } 
  /*
  mjl_detail(m) {
    if (m.stato == 'da_iniziare') {
      this.presentPopover(event, Confirm, 'Sei sicuro di voler attivare il MicroJourney ' + m.nome + '?').then((data) => {
        //console.log(data);
        if (data == 'confirm') {
          this.PostRequest('attivaMJ', m.id, {}, true, true).then((res) => {
            //console.log(res);
            //TO DO controllo che è andato sullo stato creato
            this.navCtrl.push(Mj_Detail,{mj:m});

          }).catch((e) => {
            //this.navCtrl.push(Mj_Detail,{mj:m});
            console.error(e)
          })
        }
      })
    }
    else
      this.navCtrl.push(Mj_Detail,{mj:m});
    //Open Popup p
    
  }
  open_menu() {
    //console.log('open menu');
  }
  open_page(page) {
    //console.log(page);
    this.page = page;
    for (let n in this.getbg) {
      this.getbg[n] = '';
    }
    this.getbg[page] = 'attivo';

  }
  doSomethingWithCurrentValue(ev) {
    //console.log(ev);
  }
  openconfirm(event) {
    this.presentPopover(event, Confirm, 'vuoi confermare?').then((data) => {
      //console.log(data);
    })
  }
  */
  back() {
    this.navCtrl.pop({animate:false});
  }
  go_root() {
    this.navCtrl.setRoot(Dashboard);
  }


  change_language(){
    this.storage.set('language',this.language).then((r)=>{
      this.translate.setDefaultLang(this.language); 
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/impostazioni/impostazioni.ts